import type {Action} from '@ngrx/store';
import { createReducer, on} from '@ngrx/store';
import type {AdsState} from './ads.model';
import { initialState} from './ads.model';
import {slotRenderEnded, googletagIsLoaded, startGlobalAdCycle, thirdpartyadsUpdate} from './ads.actions';
import {adMessageReceived} from './ad-messages.actions';

export const ADS_FEATURE_KEY = 'ads';
export interface AdsPartialState {
  readonly [ADS_FEATURE_KEY]: AdsState;
}

const _adsReducer = createReducer<AdsState>(
  initialState,
  on(googletagIsLoaded, (state) => ({ ...state, googletagIsLoaded: true })),
  on(startGlobalAdCycle, (state, {payload: {targetings}}): AdsState => ({
    ...state,
    currentCycle: {
      id: state.currentCycle.id + 1,
      targetings: { ...targetings },
      slotsRendered: {},
      messages: {}
    }
  })),
  on(slotRenderEnded, (state, {payload}): AdsState => ({
    ...state,
    currentCycle: {
      ...state.currentCycle,
      slotsRendered: {
        ...state.currentCycle.slotsRendered,
        [payload.adPath]: { event: payload.event, timestamp: Date.now() }
      }
    }
  })),
  on(adMessageReceived, (state, {payload}): AdsState => ({
    ...state,
    currentCycle: {
      ...state.currentCycle,
      messages: { ...state.currentCycle.messages, [payload.key]: payload.message }
    }
  })),
  on(thirdpartyadsUpdate, (state, {payload}): AdsState => ({
    ...state,
    thirdpartyads: payload.consent
  }))
)

export function adsReducer(state: AdsState, action: Action) {
  return _adsReducer(state, action);
}
